import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";
import { SheetJSFT } from "./types";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import Select from "react-select";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import "./styles.css";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSVNew from '../../../Common/exportcsvnew';


var url = window.location.hostname;
var port = window.location.port;





class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    //handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.change = this.change.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
    this.ConfirmToggle = this.ConfirmToggle.bind(this);
    this.openConfirm = this.openConfirm.bind(this);

    /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      loading_overlay: false,
      // basepack_header: [
      //   { "Warehouse": "", "Brand": "" , "Area Code": "", "Nearby area code": "", "Ranking": ""},
      // ],
      basepack_header: [
        { "Area Code": "", "Nearby area code": ""},
      ],
      showPassword: false,
	  responseModal: false,
	  responseModalMsg: null,
	  btnDisabled: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem: false,
      showInvalidProductItem: false,
      fileNameVal: "masterFile",
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsTester: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      BinMasters: [
        "Aisle",
        "Bin",
        "Bin Address",
        "Level",
        "Rack",
        "Rack Type",
        "Storage Type",
        "Zone Name",
        "Zone No.",
      ],
      /*BasePackCodes:["Base Pack Code" , "Zone Name" , "Zone No"],*/

      BasePackCodes: [
        { "Base Pack Code": "fghj", "Zone Name": "fghj", "Zone No": "fghj" },
      ],
      zoneTypeDropdown: [],
      zoneConfigDropdown: [],
      configBaskPackDropdown: [],
      config_zonecode: null,
      config_zonename: null,
      config_zonetype: null,
      config_zoneconfig: null,
      config_basepackcode: null,
      config_producttype: null,
      showZoneConfigCard: false,
      zoneOptions: [],
      validation: {

        "Basepack Zone": {
          "Base Pack Code": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },
       
      },
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  responseModalToggle = () => {
	this.setState({
		responseModal: !this.state.responseModal
	});
  }
  
  

  

 
  
  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8090";
    } else {
      url = window.location.hostname+port;
    }

  
    var cookieUsername = Util.getCookie("token");
    var location = Util.getCookie("selectedLocation");
    var username = Util.getCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: location,
      },
      () => {
        //this.config_zoneDropDown();
        //this.zoneDropdown();
      }
    );

    localStorage.setItem("userName", username);
  }

  


  SuccesstoggleCancel() {
    this.setState(
      {
        Successmodal: false,
      }/*,
      () => {
        if (document.getElementById("my_file_input") !== null) {
          document.getElementById("my_file_input").style.color = "transparent";
          document.getElementById("tester_label").style.display =
            "inline-block";
          document.getElementById("tester_label").innerHTML =
            "Select and Upload Master ";
			document.getElementById("my_file_input").style.width = "26%";
        }
        $(".upload_error").css("display", "none");
        $(".upload_success").css("display", "none");
      }*/
    );

    /*if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          

      }*/
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  ConfirmToggle() {
    this.setState((prevState) => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm() {
    this.setState({
      ConfirmModal: true,
    });
  }

  togglePressCancel() {
    

    this.setState({
      modal: false,
      modalFailed: false,
    });
  }
  



  handleChange(evt) {
	const files = evt.target.files;
	var file1 = evt.target.value;
	this.setState({
		btnDisabled: true,
        loading_overlay: true,
	}, () => {
		
		if (files && files[0]) {
		this.setState({ 
		file: files[0] 
		})
	}else{
		this.setState({ 
		loading_overlay: false,
        btnDisabled: false,
        file:{},
		})
        $(".upload_success").css('display', 'none');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
        return false;
	};
		
		var fileArray1 = file1.split(".");
		var extension1 = fileArray1[fileArray1.length - 1];

		if (document.getElementById("my_file_input") !== null) {
		  document.getElementById("my_file_input").style.color = "";
		  document.getElementById("my_file_input").style.width = "85%";
		  document.getElementById("picking_label").style.display = "none";
		}else{
			document.getElementById("my_file_input").style.width = "26%";
		}

		if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
		  $(".upload_error").css("display", "block");
		  $(".upload_success").css("display", "none");
		} else {
		  $(".upload_success").css("display", "block");
		  $(".upload_error").css("display", "none");
		  $(".button_enable").removeAttr("disabled", "disabled");
		}
		
		this.setState({
			btnDisabled: false,
            loading_overlay: false,
		});
	});
  }

  change = (selectedOption) => {
    this.setState({
      selectedOption,
      selectedFileType: selectedOption.label,
      showInvalidProductItem: false,
      showInvalidTesterItem: false,
      showRowDataErrorProduct: false,
      showRowDataErrorTester: false,
      showInvalidBaseItem: false,
      showRowDataErrorBase: false,
      showRowDataError: false,
      showInvalidItem: false,
      showZoneConfigCard: false,
    });
    $(".upload_error").css("display", "none");
    $(".upload_success").css("display", "none");
    $(".fileControl").val("");

    
  };

  validateItem = (item) => {
    const { selectedFileType, validation } = this.state;
    const dataTypes = validation[selectedFileType];
    if (dataTypes === undefined) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    const keyNames = Object.keys(dataTypes);
    if (Object.keys(item).length !== keyNames.length) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    /*if(Object.keys(item).filter(key => (keyNames.indexOf(key) === -1)).length){
      this.setState({
        error: "Invalid header of data uploaded. Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }
    if(Object.keys(item).filter(key => (typeof item[key] !== dataTypes[key])).length){
      this.setState({
        error: "Invalid datatype of data uploaded.Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }*/
    return true;
  };

  handleFile() {
    /* Boilerplate to set up FileReader */
   
	if(this.state.file.name === undefined || this.state.file.name === null){
		this.setState({
			responseModal: true,
			responseModalMsg: "Select at least one File"
		});
		return false;
    }
    this.setState({
      loading: true,
      loading_overlay: true,
    });
	const ref = this;
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        dateNf: "YYYY-MM-DD"
      });
      
		var XL_row_object = XLSX.utils.sheet_to_row_object_array(
          wb.Sheets[wsname],
          { header: 1, blankRows: false }
        );
      var json_object = XL_row_object;

      
      var mandatory_field = false;
	  var uploaded_file_header = json_object[0];

      /* if (this.state.selectedOption.value === "product_master") {
		var sample_file_header = Object.keys(this.state.product_master_header[0]);
	  }else if (this.state.selectedOption.value === "base_pack_zone") {
		var sample_file_header = Object.keys(this.state.basepack_header[0]);
	  }else if (this.state.selectedOption.value === "tester_basepack_master") {
		var sample_file_header = Object.keys(this.state.tester_header[0]);
	  }else if (this.state.selectedOption.value === "bin_master") {
		var sample_file_header = Object.keys(this.state.bin_master_header[0]);
	  } */

    var sample_file_header = Object.keys(this.state.basepack_header[0]);
	  
	  if(parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length) ){
		  ref.setState({
					loading: false,
					responseModal: true,
					responseModalMsg: "Invalid Format",
                    loading_overlay: false,
				});
				/*if (document.getElementById("my_file_input") !== null) {
				document.getElementById("my_file_input").style.color =
				  "transparent";
				document.getElementById("picking_label").style.display = "inline-block";
				document.getElementById("picking_label").innerHTML =
				  "Select and Upload Picksheet";
				}
				document.getElementById("my_file_input").style.width = "26%";
				$(".upload_error").css('display', 'none');
				$(".upload_success").css('display', 'none');*/
        return false;
	  } 
	  for (let i = 0; i < uploaded_file_header.length; i++){
		  if (uploaded_file_header[i] !== sample_file_header[i]){
			 ref.setState({
					loading: false,
					responseModal: true,
					responseModalMsg: "Invalid Format",
                    loading_overlay: false,
				});
			return false;
		  }
	  }
      
      /* Update state */
      this.setState({ data: data, cols: make_cols(ws["!ref"]) }, () => {
        let invalidItems = this.state.data.filter(
          (item) => !this.validateItem(item)
        );
        /*if(invalidItems.length > 0){

          console.log("Invalid Items", invalidItems)
          this.setState({
            showInvalidItem: true,
            showResponseData: true,
            invalidItemList: invalidItems

          })
        }else{
          console.log("Valid items");
           this.setState({
            showInvalidItem: false,

          })*/

        //if (this.state.selectedOption.value === "base_pack_zone") {
          if (invalidItems.length > 0) {
            console.log(invalidItems);
            this.setState({
              showRowDataErrorBase: false,
              showRowDataErrorProduct: false,
              showRowDataErrorTester: false,
              showRowDataError: false,
              showResponseData: true,
              ErrorRowData: invalidItems,
              showResponseData: false,
              showInvalidItem: false,
              showBaseResponseData: false,
              showInvalidBaseItem: false,
              showInvalidProductItem: false,
              showInvalidTesterItem: false,
              showProductResponseData: false,
              showFetchBaseData: false,
              showFetchProductData: false,
              showFetchTesterData: false,
              showFetchBinData: false,
            });

            console.log(Object.keys(invalidItems));
            /*alert(indexOfExt(this.state.BasePackCodes, invalidItems));*/

            /*return false*/
          }

           addAnalytics('Upload File', 'Upload Area Master', this.state.data);

          console.log(this.state.data.length);
          var arr = [];

          for (var i = 0; i < this.state.data.length; i++) {
            // <---- Move declaration inside loop

            var orderData = {};
            /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
            orderData["zoneName"] = this.state.data[i]["ZoneName"];
            orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

            //   if(this.state.data[i]["Warehouse"] == undefined || this.state.data[i]["Warehouse"] == null){
            //   orderData["warehouse"]= "";
            // }else{
            //   orderData["warehouse"] = this.state.data[i]["Warehouse"];
            // }

            //  if(this.state.data[i]["Brand"] == undefined || this.state.data[i]["Brand"] == null){
            //   orderData["brand"]= "";
            // }else{
            //   orderData["brand"] = this.state.data[i]["Brand"];
            // }

            if(this.state.data[i]["Area Code"] == undefined || this.state.data[i]["Area Code"] == null){
              orderData["area_code"]= "";
            }else{
              orderData["area_code"] = this.state.data[i]["Area Code"];
            }

            if(this.state.data[i]["Nearby area code"] == undefined || this.state.data[i]["Nearby area code"] == null){
              orderData["nearby_area_code"]= "";
            }else{
              orderData["nearby_area_code"] = this.state.data[i]["Nearby area code"];
            }

            // if(this.state.data[i]["Ranking"] == undefined || this.state.data[i]["Ranking"] == null){
            //   orderData["ranking"]= "";
            // }else{
            //   orderData["ranking"] = this.state.data[i]["Ranking"];
            // }

           

            arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr);

           const payload = {
                master_data: arr,
                master_type: "area",
                location: this.state.selectedLocation,

        };

          API.post("/customer/upload/v1/", { param: payload })

            .then((response) => {
              console.log("responeData",response.data);


              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                //showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showInvalidProductItem: true,
                responseFailProductData: response.data.data,
                showRowDataErrorTester: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                show_process_data: true,
              });

              if(response.data.success == false){
                this.toggleFailed();
              }else{
                this.Successtoggle();
                this.setState({
                 successCreatedMessage: response.data.message
                })
              }

              /*if (response.data.failure_response.length > 0) {
                this.toggleFailed();
              } else {
                this.toggle();
              }

              if (response.data.success_response.length > 0) {
                this.setState({
                  show_process_data: true,
                });
              } else {
                this.setState({
                  show_process_data: false,
                });
              } */
                this.setState({loading_overlay: false,})
				if (document.getElementById("my_file_input") !== null) {
				document.getElementById("my_file_input").style.color =
				  "transparent";
				document.getElementById("picking_label").style.display = "inline-block";
				document.getElementById("picking_label").innerHTML =
				  "Select and Upload Picksheet";
				}
				document.getElementById("my_file_input").style.width = "26%";
				$(".upload_error").css('display', 'none');
				$(".upload_success").css('display', 'none');
              /*this.fetchBaseData();*/
            })
            .catch(function (error) {
              
				if (document.getElementById("my_file_input") !== null) {
				document.getElementById("my_file_input").style.color =
				  "transparent";
				document.getElementById("picking_label").style.display = "inline-block";
				document.getElementById("picking_label").innerHTML =
				  "Select and Upload Picksheet";
				}
			
				$(".upload_error").css('display', 'none');
				$(".upload_success").css('display', 'none');
			});
       

        

        

       

        /*}*/
      });
    };

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }

 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem);
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;

  

    return (
	
      <Col xl={12}>
		  {/*<div class="overlay">
		<div class="overlay__inner">
			<div class="overlay__content"><span class="spinner"></span></div>
		</div>
		  </div>*/}
		  {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          <CardBody style={{height: 220}}>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={e => e.preventDefault()}>
             

              <div
                className="form__form-group col-xl-5"
                style={{ marginBottom: "0px" }}
              >
                <div className="row">
                  <div
                    className="col-xl-12"
                    style={{ border: "1px solid #f2f4f7" }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"
                     
                      id="my_file_input"
                      onChange={this.handleChange}
					  ref={ref=> this.fileInput = ref}
                    />
                    <label for="files" id="picking_label">
                      Select and Upload Area Master
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={this.handleFile}
					disabled ={this.state.btnDisabled}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>      
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVNew(
                      this.state.basepack_header,
                      "Area_Master_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                
              </div>
           


           
          </CardBody>

        
         

          {this.state.showInvalidProductItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                   {/* <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button> */}
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Area Code</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailProductData.length >
                    0 &&
                    this.state.responseFailProductData.map(
                      (item, index) => (
                        <tr>
                          <td>{item.id}</td>
                          {item.success == false &&
                             <td style={{ color: "red"}}>{item.message}</td>
                          }
                          {item.success == true &&
                             <td style={{ color: "green"}}>{item.message}</td>
                          }
                         
                        </tr>
                      )
                    )}

                 
                </tbody>
              </Table>
            </CardBody>
          )}

       
         

       
        </Card>
        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccesstoggleCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={ConfirmModal}
          toggle={this.ConfirmToggle}
          style={{ maxWidth: 456 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.ConfirmToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4 style={{ fontSize: 18 }}> Are you sure you want to proceed?</h4>
            <br />
            <h3 style={{ fontSize: 17 }}>
              <strong> NOTE: </strong> Duplicate entries will be updated if you
              proceed.{" "}
            </h3>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{
                backgroundColor: "#24d6a3",
                color: "#fff",
                marginRight: 8,
              }}
              className="modal_ok"
              onClick={this.processData}
            >
              Ok
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.ConfirmToggle}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>
		
		<Modal
          isOpen={this.state.responseModal}
          toggle={this.responseModalToggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.responseModalToggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.responseModalMsg}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.responseModalToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>
		
		
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));